export enum Features {
  CORPORATION_LIST = "CORPORATION_LIST",
  CORPORATION_LIST_ADD_CORP = "CORPORATION_LIST_ADD_CORP",
  CORPORATION_LIST_ELLIPSE = "CORPORATION_LIST_ELLIPSE",
  CORPORATION_DELETE = "CORPORATION_DELETE",
  CORPORATION_EDIT = "CORPORATION_EDIT",
  CORPORATION_DISABLE = "CORPORATION_DISABLE",
  CORPORATION_ENABLE = "CORPORATION_ENABLE",
  CORPORATION_ABOUT = "CORPORATION_ABOUT",
  CORPORATION_FACILITIES = "CORPORATION_FACILITIES",
  CORPORATION_FACILITIES_LINK = "CORPORATION_FACILITIES_LINK",
  CORP_SETTINGS_SECURITY_GROUP_EDIT = "CORP_SETTINGS_SECURITY_GROUP_EDIT",
  CORP_SETTINGS_SECURITY_GROUP_LIST = "CORP_SETTINGS_SECURITY_GROUP_LIST",
  CORP_SETTINGS_PAYOR_TYPE = "CORP_SETTINGS_PAYOR_TYPE",
  CORP_SETTINGS_PAYOR_PLAN = "CORP_SETTINGS_PAYOR_PLAN",
  CORP_SETTING_AUTO_FORECAST = "CORP_SETTING_AUTO_FORECAST",
  CORP_SETTINGS_CLOSE_OUT = "CORP_SETTINGS_CLOSE_OUT",

  ADD_SECURITY_GROUP = "ADD_SECURITY_GROUP",
  SECURITY_GROUP_DETAILS = "SECURITY_GROUP_DETAILS",

  FACILITY_LIST = "FACILITY_LIST",
  FACILITY_DISABLE = "FACILITY_DISABLE",
  FACILITY_EDIT = "FACILITY_EDIT",
  FACILITY_ENABLE = "FACILITY_ENABLE",
  FACILITY_DELETE = "FACILITY_DELETE",

  FACILITIES_PAYORS = "FACILITIES_PAYORS",
  FACILITIES_CONTRACTS = "FACILITIES_CONTRACTS",
  FACILITIES_AUTO_FORECAST = "FACILITIES_AUTO_FORECAST",

  FACILITIES_PHYSICIANS = "FACILITIES_PHYSICIANS",

  FACILITIES_REFERRALS = "FACILITIES_REFERRALS",
  FACILITIES_CONTACTS = "FACILITIES_CONTACTS",

  FACILITIES_VENDORS_INTEGRATIONS = "FACILITIES_VENDORS_INTEGRATIONS",
  FACILITIES_VENDORS_SPECIALTY_PROGRAM = "FACILITIES_VENDORS_SPECIALTY_PROGRAM",

  // User
  USER_LIST = "USER_LIST",

  USER_ACCOUNT_MANAGE_LOCATION_LINK = "USER_ACCOUNT_MANAGE_LOCATION_LINK",
  USER_ACCOUNT_MANAGE_LOCATION = "USER_ACCOUNT_MANAGE_LOCATION",
  USER_ACCOUNT_MANAGE_PERMISSIONS_LINK = "USER_ACCOUNT_MANAGE_PERMISSIONS_LINK",
  USER_ACCOUNT_MANAGE_PERMISSIONS = "USER_ACCOUNT_MANAGE_PERMISSIONS",
  USER_ACCOUNT_EDIT_IDENTITY = "USER_ACCOUNT_EDIT_IDENTITY",
  USER_ACCOUNT_MANAGE_FIELD_ACCOUNT_EXPIRATION = "USER_ACCOUNT_MANAGE_FIELD_ACCOUNT_EXPIRATION",
  USER_ACCOUNT_MANAGE_FIELD_PASSWORD_OVERRIDE = "USER_ACCOUNT_MANAGE_FIELD_PASSWORD_OVERRIDE",
  USER_ACCOUNT_MANAGE_FIELD_STANDARD_RATES = "USER_ACCOUNT_MANAGE_FIELD_STANDARD_RATES",
  USER_ACCOUNT_MANAGE_FIELD_MILEAGE_RATES = "USER_ACCOUNT_MANAGE_FIELD_MILEAGE_RATES",
  USER_ACCOUNT_MANAGE_FIELD_PREMIUM_RATES = "USER_ACCOUNT_MANAGE_FIELD_PREMIUM_RATES",
  USER_ACCOUNT_MANAGE_FIELD_ON_CALL_RATES = "USER_ACCOUNT_MANAGE_FIELD_ON_CALL_RATES",
  USER_ACCOUNT_MANAGE_FIELD_HOURLY_RATES = "USER_ACCOUNT_MANAGE_FIELD_HOURLY_RATES",
  USER_ACCOUNT_MANAGE_FIELD_STANDARD_RATES_MODAL = "USER_ACCOUNT_MANAGE_FIELD_STANDARD_RATES_MODAL",
  USER_ACCOUNT_MANAGE_FIELD_MILEAGE_RATES_MODAL = "USER_ACCOUNT_MANAGE_FIELD_MILEAGE_RATES_MODAL",
  USER_ACCOUNT_MANAGE_FIELD_PREMIUM_RATES_MODAL = "USER_ACCOUNT_MANAGE_FIELD_PREMIUM_RATES_MODAL",
  USER_ACCOUNT_MANAGE_FIELD_ON_CALL_RATES_MODAL = "USER_ACCOUNT_MANAGE_FIELD_ON_CALL_RATES_MODAL",
  USER_ACCOUNT_MANAGE_FIELD_HOURLY_RATES_MODAL = "USER_ACCOUNT_MANAGE_FIELD_HOURLY_RATES_MODAL",
  USER_ACCOUNT_ENABLE_USER = "USER_ACCOUNT_ENABLE_USER",
  USER_ACCOUNT_DISABLE_USER = "USER_ACCOUNT_DISABLE_USER",
  USER_ACCOUNT_RESET_PASSWORD = "USER_ACCOUNT_RESET_PASSWORD",
  USER_ACCOUNT_ADD_EXCEPTION = "USER_ACCOUNT_ADD_EXCEPTION",
  USER_ACCOUNT_ADD_RATE_MODAL = "USER_ACCOUNT_ADD_RATE_MODAL",
  AUTO_FORECAST_APPLY = "AUTO_FORECAST_APPLY",

  //Patient
  PATIENT_LIST = "PATIENT_LIST",
  ADD_PATIENT = "ADD_PATIENT",
  PATIENT_PROFILE = "PATIENT_PROFILE",
  PATIENT_FACILITY_ADMISSION = "PATIENT_FACILITY_ADMISSION",
  PATIENT_FACILITY_ADMISSION_INTERRUPTED_STAY_MERGE = "PATIENT_FACILITY_ADMISSION_INTERRUPTED_STAY_MERGE",
  PATIENT_THERAPY_EPISODES_OF_CARE = "PATIENT_THERAPY_EPISODES_OF_CARE",
  PATIENT_FORECAST = "PATIENT_FORECAST",
  PATIENT_THERAPY_BILLING = "PATIENT_THERAPY_BILLING",
  PATIENT_TIMECARD = "PATIENT_TMECARD",
  PATIENT_TIMECARD_OTHER = "PATIENT_TMECARD_OTHER",
  PATIENT_TMECARD_TIME_IN_OUT = "PATIENT_TMECARD_TIME_IN_OUT",

  AGENDA = "AGENDA",

  REPORTS = "REPORTS",

  //Co-Sign
  CO_SIGN = "CO_SIGN",
  CO_SIGN_TEAM = "CO_SIGN_TEAM",

  //Patient Document Security Groups
  PATIENT_DOCUMENTATION = "PATIENT_DOCUMENTATION",
  PATIENT_DOCUMENTS_DELETE_AND_RESTORE = "PATIENT_DOCUMENTS_DELETE_AND_RESTORE",
  PATIENT_DOCUMENTS_INITIATE_EPOC = "PATIENT_DOCUMENTS_INITIATE_EPOC",
  PATIENT_DOCUMENTS_EPOC = "PATIENT_DOCUMENTS_EPOC",
  PATIENT_DOCUMENTS_PR = "PATIENT_DOCUMENTS_PR",
  PATIENT_DOCUMENTS_RCUPOC = "PATIENT_DOCUMENTS_RCUPOC",
  PATIENT_DOCUMENTS_DC = "PATIENT_DOCUMENTS_DC",

  //Physicican Certifications
  PHYSICIAN_CERTIFICATIONS = "PHYSICIAN_CERTIFICATIONS",

  //Bi Dashboard
   DASHBOARD = "DASHBOARD",

  CLOSE_OUT = "CLOSE_OUT"
}
